import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  jobData: null,
};

const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {
    createJobStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createJobSuccess: (state, action) => {
      state.loading = false;
      state.jobData = action.payload;
    },
    createJobFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { createJobStart, createJobSuccess, createJobFailure } = jobSlice.actions;
export default jobSlice.reducer;
